import React from "react";
import { Navigate, useLocation } from "react-router-dom";


const PublicRoute = ({ ...rest }) => {
    const location = useLocation();

        return (
            <>
              
                {rest.element}
            </>
        );
    } 


export default PublicRoute;
